import React, {
  useCallback,
} from 'react';
import { ListParams } from '../../types/main';
import { SelectProps } from './types';
import BaseSearchSelect from './BaseSearchSelect';
import ScenesService from '../../services/ScenesService';

const SceneField = (props: SelectProps) => {
  const defaultParams: ListParams = {
    page_size: 10,
  };

  const searchOptionsHandler = useCallback(async (params: ListParams) => {
    const records = await ScenesService.list({ ...defaultParams, ...params });

    return records.items?.map((item) => ({
      label: item.title,
      id: item.id,
    })) || [];
  }, [defaultParams]);

  return (
    <BaseSearchSelect
      searchOptions={searchOptionsHandler}
      {...props}
    />
  );
};

export default SceneField;
